
export enum FeatureKey {
  ShowSupportWidget = "UX.Support.ShowWidget",
  ShowL4LCheckBox = "UX.L4L.ShowCheckBox"
}
